import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

import MyNavbar from "./components/Navbar";
// import HeroSection from "./components/HeroSection";
import AboutUs from './components/AboutUs';
import Certifications from './components/Certifications';
import Services from './components/Services';
import Ice from './components/Ice';
import IceRegistration from './components/IceRegistration';
import Careers from './components/Careers';
import ContactUs from './components/ContactUs';
import MarketPlace from './components/MarketPlace';
import Team from './components/Team';
import Workplace from './components/Workplace';
import Footer from './components/Footer';
import Home from './components/Home';

const App = () => {
  return (
    <Router>
      <MyNavbar />  
      <div> 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/certifications" element={<Certifications />} />
          <Route path="/services" element={<Services />} />
          <Route path="/team" element={<Team />} />
          <Route path="/workplace" element={<Workplace />} />
          <Route path="/ice" element={<Ice />} />
          <Route path="/ice-registration" element={<IceRegistration />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/marketplace" element={<MarketPlace />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;

// import React from 'react'
// import './App.css';

// import MyNavbar from "./components/Navbar";
// import HeroSection from "./components/HeroSection";
// import AboutUs from './components/AboutUs';
// import Certifications from './components/Certifications';
// import Services from './components/Services';
// import Security from './components/Security';
// import Ice from './components/Ice';
// import IceRegistration from './components/IceRegistration';
// import Careers from './components/Careers';
// import ContactUs from './components/ContactUs';
// import MarketPlace from './components/MarketPlace';


// const App = () => {
//   return (
//     <>
//       <MyNavbar />
//       <HeroSection />
//       <AboutUs />
//       < Certifications />
//       <Services />
//       {/* <Security />   */}
//       <Ice />
//       <IceRegistration />
//       <Careers />
//       <ContactUs />
//       <MarketPlace />
//     </>
//   );
// };

// export default App;